import { useState } from "react";
import { Route, Switch } from "react-router-dom";

import OrganizationsListPage from "../pages/organization/OrganizationsListPage";
import OrganizationPage from "../pages/organization/OrganizationPage";
import OrganizationForm from "../pages/organization/OrganizationForm";
import UniversalSearch from "../pages/UniversalSearch";
import UsersListPage from "../pages/user/UserListPage";
import UserPage from "../pages/user/UserPage";
import UserForm from "../pages/user/UserForm";
import SettingsPage from "../pages/settings/SettingsPage";
import ProjectListPage from "../pages/project/ProjectListPage";
import ProjectDetailPage from "../pages/project/ProjectDetailPage";
import ProjectForm from "../pages/project/ProjectForm";
import TaskListPage from "../pages/task/TaskListPage";
import TaskDetailPage from "../pages/task/TaskDetailPage";
import Header from "../navigation/Header";
import TaskForm from "../pages/task/TaskForm";
import Home from "../pages/Home";
import Sidebar from "../navigation/Sidebar";
import useDebounce from "../../hooks/useDebounce";
import { AppDataContextProvider } from "../../context/AppDataContext";
import { TimeTrackingContextProvider } from "../../context/TimeTrackingContext";
import SprintListPage from "../pages/sprint/SprintListPage";
import SprintDetailPage from "../pages/sprint/SprintDetailPage";
import SprintForm from "../pages/sprint/SprintForm";
import CompaniesListPage from "../pages/company/CompaniesListPage";
import CompanyPage from "../pages/company/CompanyPage";
import CompanyForm from "../pages/company/CompanyForm";
import ContactsListPage from "../pages/contact/ContactsListPage";
import ContractListPage from "../pages/contract/ContractListPage";
import ContractDetailPage from "../pages/contract/ContractDetailPage";
import ContractForm from "../pages/contract/ContractForm";
import DeveloperReportPage from "../pages/reports/DeveloperReportPage";
import PreviousTaskNotification from "../ui/PreviousTaskNotification";
import NotificationsContainer from "../notification/NotificationsContainer";

const PrivateRoutes = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const searchDebounce = useDebounce(searchTerm);

  return (
    <AppDataContextProvider>
      <TimeTrackingContextProvider>
        <Sidebar />
        <div
          className="flex-columns px-5"
          style={{
            flex: "1",
            minWidth: "0",
          }}
        >
          <Route
            path="/"
            render={(routeProps) => (
              <Header
                {...routeProps}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            )}
          />

          <div className="body-container">
            <Switch>
              <Route path="/home" component={Home} />

              <Route exact path="/users" component={UsersListPage} />
              <Route path="/user/:user_id" component={UserPage} />
              <Route exact path="/user-add" component={UserForm} />
              <Route exact path="/contact-add" component={UserForm} />
              <Route path="/user-add/:user_id" component={UserForm} />

              <Route
                path="/notifications/new"
                component={NotificationsContainer}
              />
              <Route
                path="/notifications/cleared"
                component={NotificationsContainer}
              />

              <Route path="/organizations" component={OrganizationsListPage} />
              <Route path="/organization/:orgId" component={OrganizationPage} />
              <Route
                exact
                path="/organization-form"
                component={OrganizationForm}
              />
              <Route
                path="/organization-form/:orgId"
                component={OrganizationForm}
              />

              <Route path="/settings" component={SettingsPage} />

              <Route exact path="/projects" component={ProjectListPage} />
              <Route path="/project/:projectId" component={ProjectDetailPage} />
              <Route exact path="/project-form" component={ProjectForm} />
              <Route path="/project-form/:projectId" component={ProjectForm} />
              <Route exact path="/tasks" component={TaskListPage} />
              <Route exact path="/task/:taskId" component={TaskDetailPage} />
              <Route exact path="/task-form/:taskId" component={TaskForm} />
              <Route exact path="/task-form" component={TaskForm} />
              <Route exact path="/sprints" component={SprintListPage} />
              <Route
                exact
                path="/sprint/:sprintId"
                component={SprintDetailPage}
              />
              <Route exact path="/sprint-form" component={SprintForm} />
              <Route path="/sprint-form/:sprintId" component={SprintForm} />

              <Route exact path="/companies" component={CompaniesListPage} />
              <Route path="/company/:companyId" component={CompanyPage} />
              <Route exact path="/contacts" component={ContactsListPage} />

              <Route exact path="/company-form" component={CompanyForm} />
              <Route path="/company-form/:companyId" component={CompanyForm} />

              <Route exact path="/contracts" component={ContractListPage} />
              <Route
                path="/contract/:contractId"
                component={ContractDetailPage}
              />
              <Route exact path="/contract-form" component={ContractForm} />
              <Route
                path="/contract-form/:contractId"
                component={ContractForm}
              />

              <Route exact path="/reports" component={DeveloperReportPage} />

              <Route
                path="/universal-search"
                render={(routeProps) => (
                  <UniversalSearch
                    {...routeProps}
                    searchTerm={searchDebounce}
                  />
                )}
              />
            </Switch>
          </div>
        </div>
        <PreviousTaskNotification />
      </TimeTrackingContextProvider>
    </AppDataContextProvider>
  );
};

export default PrivateRoutes;
